import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '@/components/site/Navbar';
import Footer from '@/components/site/Footer';
import { Toaster } from '@/components/ui/sonner';

export default function SiteLayout() {
  const location = useLocation();

  React.useEffect(() => {
    // Scroll to top on route change unless there's a hash
    if (!location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
    } else {
      // small delay for the section to mount
      setTimeout(() => {
        const el = document.getElementById(location.hash.replace('#', ''));
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen bg-[#000919] text-white">
      <Navbar />
      <main className="pt-20">
        <Outlet />
      </main>
      <Footer />
      <Toaster richColors position="bottom-right" theme="dark" />
    </div>
  );
}
